import ContactDesk from "../components/ContactPage/Desk/ContactDesk";
import ContactMob from "../components/ContactPage/Mob/ContactMob";

const ContactPage = () => {
  return <>{window.innerWidth <= 767 ? <ContactMob /> : <ContactDesk />}</>;
};

export default ContactPage;
